import { read, utils, writeFile, writeFileXLSX } from 'xlsx';
import { TODAY } from './constants';

// Excel sheet names must be ≤31 chars and cannot contain: / \ ? * [ ]
// Use status suffix as sheet name (e.g. "Cursos_EnProceso"), fallback to index
const sanitizeSheetName = (name, index) => {
  const suffixMatch = name.match(/(EnProceso|Aprobado|Cerrado|Rechazado)$/);
  if (suffixMatch) return `Cursos_${suffixMatch[1]}`;
  return `Cursos_${index + 1}`;
};

export const exportExcell = async (objects, fileName) => {
  try {
    var wb = utils.book_new();
    objects.map((data, index) => {
      const ws = utils.json_to_sheet(data.info);
      utils.book_append_sheet(wb, ws, sanitizeSheetName(data.name, index));
    });
    return writeFileXLSX(wb, `${fileName}-${TODAY}.xlsx`, {
      compression: true,
      cellDates: true,
    });
  } catch (e) {
    console.log('ERROR', e);
  }
};
